import React, { useContext, useEffect, useRef } from "react";
import { StateContext } from "./state";
import { Search } from "./Search";

export const Input = ({ activeSearchHandler, index }) => {
  const containerRef = useRef();
  const { hotels, removeHotel, activeSearch } = useContext(StateContext);
  useEffect(() => {
    const handler = (e) => {
      if (!containerRef.current.contains(e.target) && activeSearch === index) {
        activeSearchHandler(null);
        
      }
      if (activeSearch === null) {
        document.removeEventListener("click", handler);
      }
    };
    document.addEventListener("click", handler, false);
    return () => document.removeEventListener("click", handler);
  }, [activeSearch]);

  return (
    <div className="hotel-list__wrapper" ref={containerRef}>
      {hotels[index] ? (
        <div className="hotel-list__inner">
          <div className="hotel-list__inner-right">
            <p>
              {Drupal.t("Hotel List No")}. {index}
            </p>
            <div className="hotel-list__title">{hotels[index].title}</div>
          </div>
          {hotels[index].field_taxonomy_image && (
            <img
              className="hotel-list__img"
              src={hotels[index].field_taxonomy_image}
            />
          )}
          <button
            className="hotel-close"
            onClick={() => removeHotel(index)}
          ></button>
        </div>
      ) : (
        <>
          <div
            id={'each-'+index}
            className={`hotel-input  ${activeSearch === index ? "active" : ""}`}
            onClick={() => activeSearchHandler(index)}
          >
            <span className="hotel-label">{Drupal.t("Hotel")}</span>{" "}
            <span>
              {Drupal.t("Hotel List")} {index}
            </span>
          </div>
          {activeSearch === index && (
            <Search activeSearchHandler={activeSearchHandler} index={index} />
          )}
        </>
      )}
    </div>
  );
};
